var _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCss3(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 200,
    height: 200,
    fill: "none",
    viewBox: "0 0 200 200",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#264de4",
    d: "m170 21-12.754 142.881-57.332 15.894-57.173-15.871L30 21z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#2965f1",
    d: "m146.327 154.783 10.899-122.098H100v134.942z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "#ebebeb",
    d: "m59.208 85.685 1.57 17.527H100V85.685zM100 50.211H56.052l1.593 17.527H100zm0 99.227v-18.235l-.077.021-19.52-5.271-1.247-13.978H61.562l2.456 27.519 35.901 9.967z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "m121.521 103.211-2.034 22.731-19.547 5.276v18.234l35.93-9.958.263-2.961 4.119-46.141.428-4.707 3.164-35.474H99.94v17.527h24.696l-1.595 17.947H99.94v17.526z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCss3);
export default __webpack_public_path__ + "static/media/css3.a1488e6dfa2da66ed07b838d48242ea9.svg";
export { ForwardRef as ReactComponent };